<template>
  <div class="move-line" ref="mLine">
    
  </div>
</template>

<script>
export default {
  props:{},
  data() {
    return {
      
    };
  },
  mounted(){
    // 鼠标按下事件
    this.$refs.mLine.onmousedown = (e) =>{
      // 鼠标拖动事件
      document.onmousemove = (e)=> {
        if(e.clientX<=210 || e.clientX>=500){
          return
        }
        this.$emit("move",e.clientX)
      }
      // 鼠标松开事件
      document.onmouseup = (e)=> {
        document.onmousemove = null;
        document.onmouseup = null;
      }
    }
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
.move-line  {
  cursor: col-resize;
  user-select: none;
  &:active {
    background-color: red;
  }
}

</style>
